<template>
  <body>

    <b-navbar toggleable="md" type="dark" variant="dark" :class="'sticky-top p-0 shadow' + (isSiteAdmin ? ' is-site-admin' : '')">

      <b-navbar-brand to="/">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="51" height="44" viewBox="0 0 1280.000000 1104.000000" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,1104.000000) scale(0.100000,-0.100000)" fill="#ededed" stroke="none">
            <path d="M6410 10632 l0 -389 -219 -183 -218 -184 -7 -170 c-3 -94 -11 -445
              -16 -781 -12 -674 -16 -775 -33 -775 -7 0 -957 -97 -2111 -215 -1551 -159
              -2101 -213 -2107 -204 -4 6 -10 34 -13 62 -9 66 -29 113 -55 127 -18 9 -23 7
              -40 -21 -11 -19 -22 -60 -26 -98 -3 -36 -7 -73 -8 -81 -2 -15 -57 -24 -284
              -45 -68 -6 -73 -8 -73 -30 0 -25 19 -30 208 -57 132 -18 134 -40 24 -309 -155
              -381 -395 -1065 -765 -2184 -275 -833 -537 -1643 -537 -1664 0 -7 -23 -11 -65
              -11 -78 0 -78 -2 -39 -112 64 -177 178 -360 317 -505 295 -308 693 -468 1217
              -489 580 -24 1067 169 1366 540 125 155 224 347 272 528 l10 38 -779 0 -779 0
              0 33 c0 18 7 192 15 387 34 817 64 1962 68 2600 1 179 5 318 9 310 4 -8 34
              -94 68 -190 189 -537 701 -1847 1080 -2765 62 -148 119 -289 128 -312 15 -41
              42 -57 56 -35 5 9 -164 525 -413 1262 -400 1185 -690 2009 -884 2505 -49 125
              -55 150 -59 233 l-4 93 25 -5 c14 -3 98 -17 186 -30 88 -14 387 -61 665 -105
              1333 -212 2195 -348 2720 -431 316 -50 581 -93 588 -95 10 -4 12 -38 7 -162
              -3 -87 -10 -396 -15 -688 -6 -291 -15 -744 -20 -1005 -12 -566 -26 -1263 -40
              -1975 -24 -1154 -29 -1330 -41 -1368 -16 -48 -84 -127 -110 -127 -10 0 -19 -5
              -19 -11 0 -15 -112 -63 -205 -87 -207 -54 -430 -79 -840 -93 -164 -5 -300 -11
              -301 -12 -14 -14 -72 -589 -85 -839 -13 -242 -5 -401 25 -473 l15 -35 2159 0
              2160 0 15 32 c9 18 21 64 28 103 17 99 6 529 -20 780 -20 187 -50 427 -55 432
              -1 1 -137 7 -301 12 -538 18 -831 63 -1014 156 -78 39 -146 107 -160 162 -13
              49 -19 226 -31 883 -10 534 -22 1103 -40 1980 -34 1664 -34 1628 -16 1645 21
              21 21 148 1 380 -9 94 -18 202 -21 240 l-7 70 139 23 c143 23 2439 386 3394
              537 294 47 552 88 573 91 32 5 37 3 37 -14 0 -11 -29 -91 -64 -179 -108 -267
              -248 -653 -433 -1198 -261 -768 -883 -2673 -883 -2704 0 -7 -24 -11 -69 -11
              l-69 0 19 -64 c121 -401 433 -738 838 -902 496 -202 1162 -188 1605 33 276
              137 508 368 644 638 43 87 102 245 102 276 0 19 -17 19 -780 19 l-780 0 0 48
              c0 27 7 199 15 383 39 898 73 2124 76 2714 1 203 1 208 16 165 224 -651 639
              -1721 1241 -3202 26 -64 40 -88 53 -88 10 0 20 4 23 9 8 13 -541 1652 -882
              2631 -141 405 -339 951 -412 1135 -46 117 -52 140 -58 238 -7 103 -6 108 13
              112 20 5 332 55 340 55 3 0 5 11 5 25 0 19 -5 25 -22 26 -13 0 -97 8 -187 17
              l-165 17 -7 30 c-4 17 -13 57 -19 89 -8 38 -21 68 -37 84 -25 24 -25 25 -44 5
              -14 -14 -23 -45 -32 -106 l-12 -88 -40 6 c-49 7 -4135 425 -4151 425 -17 0
              -22 127 -34 855 -6 347 -13 684 -16 751 l-6 120 -219 184 -219 183 0 389 0
              388 -25 0 -25 0 0 -388z m4730 -5117 c12 -731 36 -1767 45 -1962 l7 -133 -707
              0 c-562 0 -706 3 -702 13 3 6 51 127 107 267 508 1270 915 2351 1137 3021 l98
              295 2 -430 c1 -237 7 -719 13 -1071z m-9608 1413 c-5 -103 15 -1546 28 -2078
              15 -592 29 -1106 36 -1277 l6 -153 -712 0 c-566 0 -711 3 -707 13 177 432 682
              1727 864 2212 182 487 379 1043 450 1272 15 51 30 93 33 93 3 0 3 -37 2 -82z"/>
          </g>
        </svg>
        Justice Story
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav class="px-3">
          <b-nav-item v-if="applicationUser && isClient">{{applicationUser.firstName}} {{applicationUser.lastName}}, Client of {{applicationUser.client.subscriptionUser.applicationUser.displayName}}</b-nav-item>
          <b-nav-item to="/" v-if="applicationUser && (isSubscriber || isSiteAdmin)">{{applicationUser.firstName}} {{applicationUser.lastName}}</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isSubscriber" right to="/">My Clients</b-nav-item>
          <b-nav-item v-if="isSubscriber" right to="/subscriber/manageSubscription">My Subscription</b-nav-item>
          <!-- <b-nav-item-dropdown right>
            <template slot="button-content">
              Wireframes
            </template>
            <b-dropdown-item to="/wireframe/subscriberDashboard">Attorney/Subscriber: Dashboard</b-dropdown-item>
            <b-dropdown-item to="/wireframe/inviteClient">Attorney/Subscriber: Invite Client</b-dropdown-item>
            <b-dropdown-item to="/wireframe/subscriberClientOverview">Attorney/Subscriber: Client Overview</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientLanding">Client: Landing</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio1">Client: Bio 1</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio2">Client: Bio 2</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio3">Client: Bio 3</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientGad">Client: GAD Assessment</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <b-nav-item right to="/page/client-help" v-if="isClient">Help</b-nav-item>
          <b-nav-item right to="/page/subscriber-help" v-if="isSubscriber">Help</b-nav-item>
          <!-- <b-nav-item right to="/testingNotes">Testing Notes</b-nav-item> -->
          <b-nav-item-dropdown right v-if="isSiteAdmin">
            <template slot="button-content">
              Debug
            </template>
            <b-dropdown-item href="/hangfire" target="_blank">Hangfire Dashboard</b-dropdown-item>
            <b-dropdown-item href="/swagger" target="_blank">Swagger UI</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template slot="button-content">
              {{$root.$data.authenticatedUser.username ? $root.$data.authenticatedUser.username : 'Not Logged In'}}
            </template>
            <b-dropdown-item to="/subscribe" v-if="!$root.$data.authenticatedUser.username">Sign Up</b-dropdown-item>
            <b-dropdown-item to="/changePassword" v-if="$root.$data.authenticatedUser.username && !isClient">Change Password</b-dropdown-item>
            <b-dropdown-item to="/verifyPhonenumber" v-if="$root.$data.authenticatedUser.username && !isClient">Enable Two Factor Authentication</b-dropdown-item>
            <b-dropdown-item to="/login" v-if="!$root.$data.authenticatedUser.username">Log In</b-dropdown-item>
            <b-dropdown-item to="/logout" v-if="$root.$data.authenticatedUser.username">Log Out</b-dropdown-item>
          </b-nav-item-dropdown>
          
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <b-alert v-if="updateExists" class="py-3 my-0" show dismissable variant="secondary">
      <span class="mr-3">An updated version of Justice Story is available.</span>
      <b-button @click="refreshApp" class="ml-3">Update Now</b-button>
    </b-alert>

    <div class="container-fluid">
      <div class="row">

        <nav v-if="isSiteAdmin" id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
          <div class="sidebar-sticky pt-3">

            <b-nav vertical>
              <b-nav-item to="/">Dashboard</b-nav-item>
            </b-nav>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="isSiteAdmin">
              <span>Admin</span>
            </h6>

            <b-nav vertical v-if="isSiteAdmin">
              <b-nav-item to="/applicationUser">Users</b-nav-item>
              <b-nav-item to="/subscription">Subscriptions</b-nav-item>
              <b-nav-item to="/client">Clients</b-nav-item>
              <b-nav-item to="/template">Templates</b-nav-item>
              <b-nav-item to="/contentBlock">Content</b-nav-item>
            </b-nav>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="isSiteAdmin">
              <span>Debug</span>
            </h6>

            <b-nav vertical v-if="isSiteAdmin">
              <b-nav-item href="/hangfire" target="_blank">Hangfire</b-nav-item>
              <b-nav-item href="/swagger" target="_blank">Swagger</b-nav-item>
            </b-nav>

          </div>
        </nav>

        <main role="main" :class="(isSiteAdmin ? 'col-md-9 col-lg-10 is-site-admin ' : '') + 'ml-sm-auto px-md-4 w-100'">
          <!-- ml-sm-auto -->
          <router-view></router-view>
        </main>
      </div>
    </div>

    <footer class="footer">
      <div :class="'bg-secondary text-light ' + (!isSiteAdmin ? 'container text-center' : 'text-right pr-3')">
        <span class="footer-link">Copyright &copy; 2020-2024 Justice Story</span>
        &bull;
        <span class="footer-link"><b-link href="https://www.justicestory.com">Home</b-link></span>
        &bull;
        <span class="footer-link"><b-link to="/page/terms-and-conditions">Terms and Conditions</b-link></span>
        <span v-if="isSubscriber || isSiteAdmin">&bull;</span>
        <span class="footer-link"><b-link to="/page/contact-us">Contact Us</b-link></span>
      </div>
    </footer>

  </body>
</template>

<script>
import axios from "axios";
import AuthMixin from './components/Mixins/AuthMixin.vue'
import EventBus from './components/Common/EventBus.js'
import AppUpdateMixin from './components/Mixins/AppUpdate.vue'

export default {
  name: 'app',
  mixins: [AuthMixin, AppUpdateMixin],
  data() {
    return {
      applicationUser: null
    };
  },
  computed: {
    isSiteAdmin: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Site Admin');
    },
    isSubscriber: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Subscriber');
    },
    isClient: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Client');
    }
  },
  methods: {
    showToast: function (text, options) {
      this.$bvToast.toast(text, options);
    },
    loadUser: function () {
      if (!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.id) {
        this.applicationUser = null;
        return;
      }

      const userId = this.$root.$data.authenticatedUser.id;
      const generation = this.$root.$data.authGeneration || 0;
      axios
        .get('/api/applicationUser/' + userId + '?includes=Client,Client.SubscriptionUser,Client.SubscriptionUser.Subscription,Client.SubscriptionUser.ApplicationUser')
        .then(response => {
          if (this.$root.$data.authenticatedUser.id === userId &&
              (this.$root.$data.authGeneration || 0) === generation)
            this.applicationUser = response.data;
        })
        .catch(error => {
          console.log(error);
        });    

    }
  },
  mounted() {
    EventBus.$on('authenticated', authenticatedUser => {
      this.loadUser();
    })

    this.refreshAuthenticationData();



    // if ((!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.username) && localStorage.getItem('jwt')) {
    //   axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');

    //   this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
    //   this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
    //   this.$root.$data.authenticatedUser.roles = JSON.parse(localStorage.getItem('roles'));
    // }
  }
}
</script>
